{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "passo-uno:seven-action:1.0",
  "title": "Seven-Action Documentation Model v1.0",
  "description": "Constrains `action` to the seven reader actions of the Seven-Action Documentation Model (upstream model version 2025-01-09). `action` names what the reader is doing, which is independent of what the page is, so this schema composes with a content-type schema keyed on `type`. Vocabulary only: `action` is not required. See https://passo.uno/seven-action-model/",
  "type": "object",
  "additionalProperties": true,
  "properties": {
    "action": {
      "type": "string",
      "enum": [
        "appraise",
        "understand",
        "explore",
        "practice",
        "remember",
        "develop",
        "troubleshoot"
      ],
      "description": "What the reader is trying to do on this page: `appraise` (discern whether something fits), `understand` (learn a concept), `explore` (discover what exists), `practice` (train a skill), `remember` (recall a detail), `develop` (integrate it into their own work), or `troubleshoot` (solve a problem)."
    }
  }
}
